import React from 'react';

const GraphLoading = () => (
  <text y='500' x='560' style={{
    fontSize: '150px',
    letterSpacing: '200px',
    opacity: 0.5,
  }}>
    Loading
    <animate
      attributeName='opacity'
      from='0'
      to='1'
      repeatCount='indefinite'
      dur='0.2s'
    />
  </text>
);

export default GraphLoading;
